import axios from "../services/axios";
import parseError from "../../utils/errorParse";
import { ensureFreshToken, getStoredAccessToken, isTokenExpired } from "../../helpers/tokenManager";

function withAPIKeys(params) {
  var tenantId = params?.tenantId;
  var forcedToken = params?.forcedToken;
  var extraHeaders = params?.headers;
  if(forcedToken){
    return {
      headers: {
        Authorization: `Bearer ${forcedToken}`,
        "Content-Type": "application/json",
        ...extraHeaders,
      },
    };
  }

  // Keeps the token fresh in the background; the token manager's proactive
  // scheduler is the primary mechanism, this is just a safety net.
  ensureFreshToken().catch(() => {});

  const token = getStoredAccessToken();
  return {
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
      "Content-Type": "application/json",
      ...(tenantId && { "Tenant-ID": tenantId }),
      ...extraHeaders,
    },
  };
}

function withMultipartAPIKeys() {
  ensureFreshToken().catch(() => {});

  const token = getStoredAccessToken();
  return {
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
      "Content-Type": "multipart/form-data",
    },
  };
}

function CustomHeadersForPdf() {
  const token = getStoredAccessToken();
  return {
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
      Accept: "application/pdf",
    },
    responseType: "blob",
  };
}

const addPageNumber = (url, params) => {
  let str = "";
  if (params.pageNumber) {
    str = `pageNumber=${params.pageNumber}`;
  }
  if (params.pageSize) {
    str = `${str}${str ? "&" : ""}pageSize=${params.pageSize}`;
  }

  return str ? `${url}?${str}` : url;
};

export const apiCall = {
  pagination: (payload) =>
    axios
      .get(payload.url, withAPIKeys())
      .then((response) => response)
      .catch((error) => parseError(error)),
  get: (payload) =>
    axios
      .get(payload.url, withAPIKeys(payload.tenantId))
      .then((response) => {
        return response.data;
      })
      .catch((error) => parseError(error)),
  post: (payload) =>
    axios
      .post(payload.url, payload.params, withAPIKeys({tenantId: payload.tenantId, forcedToken: payload.forcedToken, headers: payload.headers}))
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        const err = parseError(error);
        throw err;
        // throw new Error(JSON.stringify(err.data));
        // throw new Error(JSON.stringify(err.data.errors));
      }),
  put: (payload) =>
    axios
      .put(payload.url, payload.params, withAPIKeys())
      .then((response) => response.data)
      .catch((error) => {
        const err = parseError(error);
        throw err;
      }),
  patch: (payload) =>
    axios
      .patch(payload.url, payload.params, withAPIKeys())
      .then((response) => response.data)
      .catch((error) => {
        const err = parseError(error);
        throw err;
      }),
  delete: (payload) =>
    axios
      .delete(payload.url, withAPIKeys())
      .then((response) => response.data)
      .catch((error) => {
        const err = parseError(error);
        // throw new Error(err.data.message);
        throw err;
      }),
  file: (payload) =>
    axios
      .put(payload.url, payload.params, withMultipartAPIKeys())
      .then((response) => response.data)
      .catch((error) => parseError(error)),
  filePost: (payload) =>
    axios
      .post(payload.url, payload.params, withMultipartAPIKeys())
      .then((response) => response.data)
      .catch((error) => parseError(error)),
  pdf: (payload) =>
    axios
      .get(payload.url, CustomHeadersForPdf())
      .then((response) => response.data)
      .catch((error) => parseError(error)),
  pdfPost: (payload) =>
    axios
      .post(payload.url,payload.params, CustomHeadersForPdf())
      .then((response) => response.data)
      .catch((error) => parseError(error)),
  getFile: (payload) => {
    const token = getStoredAccessToken();
    return axios
      .get(payload.url, {headers: {...payload.headers, ...(token && { Authorization: `Bearer ${token}` })}, responseType: payload.responseType})
      .then((response) => response)
      .catch((error) => parseError(error));
  },
};

export const isTokenValid = () => !isTokenExpired();

export const buildQueryParams = (queryObject) => {
  const params = new URLSearchParams();
  for (const key in queryObject) {
    const value = queryObject[key];
    if (value !== undefined && value !== null && value !== "") {
      params.append(key, value);
    }
  }

  return params.toString();
};
export { handleLogout } from "../../helpers/tokenManager";
